import script from "./PageTemplate.vue?vue&type=script&setup=true&lang=js"
export * from "./PageTemplate.vue?vue&type=script&setup=true&lang=js"

import "./PageTemplate.vue?vue&type=style&index=0&id=592dfde9&lang=css"

const __exports__ = script;

export default __exports__